export const TooltipStyle = {
  // Styles for the base style
  baseStyle: () => ({
    borderRadius: 'lg',
  }),
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {},
}
